/**
 * i18n utility – extracts the correct language string from a multilingual field.
 *
 * Multilingual fields are stored in Firestore as:
 *   { en: "English text", de: "German text", fa: "متن فارسی" }
 *
 * Legacy plain-string fields are returned as-is for backward compatibility.
 */

export const LANGUAGES = [
    { code: 'en', label: 'EN', name: 'English', dir: 'ltr' },
    { code: 'de', label: 'DE', name: 'Deutsch', dir: 'ltr' },
    { code: 'fa', label: 'FA', name: 'فارسی', dir: 'rtl' },
];

export const DEFAULT_LANG = 'en';

/**
 * Extracts the text for the given language from a field.
 * Falls back: requested lang → 'en' → raw string → ''
 *
 * @param {string|Object} field  - Plain string or { en, de, fa } object
 * @param {string}        lang   - Language code
 * @returns {string}
 */
export function t(field, lang = DEFAULT_LANG) {
    if (!field) return '';
    if (typeof field === 'string') return field;
    if (typeof field === 'object') {
        return field[lang] || field[DEFAULT_LANG] || Object.values(field)[0] || '';
    }
    return String(field);
}

/**
 * Checks whether a field is stored in the multilingual object format.
 */
export function isMultilingual(field) {
    return field !== null &&
        typeof field === 'object' &&
        !Array.isArray(field) &&
        ('en' in field || 'de' in field || 'fa' in field);
}

/**
 * Wraps a plain string into a multilingual object, using the string as the
 * English value and empty strings for the other languages.
 */
export function toMultilingual(str) {
    return { en: str || '', de: '', fa: '' };
}
